export const hasValue = (value: any): boolean => {
  if (Array.isArray(value)) return value.length > 0;
  if (typeof value === 'string') return !!value.trim();
  if (typeof value === 'boolean') return value;
  return typeof value !== 'undefined';
};
